// constants/chat.constants.ts

export const CHAT_CONSTANTS = {
  STORAGE_KEYS: {
    SESSION_ID: 'conversationId'
  },
  AUTH: {
    MOCK_KEY: 'mock-auth-key'
  },
  OPCODES: {
    HOTEL_SEARCH: 'HTL_SEARCH',
    AGENT_PERFORM: 'AGENT_PERFORM',
    BOOKING_VIEW: 'BKG_VIEW'
  },
  SENDERS: {
    BOT: 'bot',
    USER: 'user'
  },
  URLS: {
    MOCK_AGENT: 'http://mock-api/agent',
    AGENT: 'http://192.168.5.160:7006/api/agent',
    BOOKING_PATH: '/b2b-booking/?bkgId='
  },
  TIMERS: {
    HIDE_BUBBLE_INFO: 5000,
    MOCK_STREAM_DELAY: 1000
  },
  MESSAGE_TYPES: {
    TEXT: 'text',
    TABLE: 'table',
    COMPONENT: 'component'
  },
  TABLE_TYPES: {
    HOTEL: 'hotel',
    DYNAMIC: 'dynamic'
  },
  COMPONENT_TYPES: {
    PROMPT_SUGGESTION_LIST: 'PromptSuggestionList'
  },
  SLIDER: {
    DEFAULT_SCROLL: 200,
    DIRECTION: {
      LEFT: 'left',
      RIGHT: 'right'
    }
  },
  REGEX: {
    NOTIFICATION: /<<notification>>(.*?)<<\/notification>>/gs,
    CONTENT: /<TABLE>\s*(.*?)\s*<\/TABLE>|<CHAT_VIEW><COMPONENT>(.*?)<\/COMPONENT><\/CHAT_VIEW>|<COMPONENT>(.*?)<\/COMPONENT>/gs
  },
  EXCLUDE_MARKERS: [
    '**Conversation so far:**',
    '**Here’s a summary of our conversation so far:**'
  ]
};
